import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { class: "control" }
const _hoisted_3 = ["placeholder", "min", "max", "required", "name", "id", "value"]

import { computed, ref, watch } from "vue";

interface Props {
  formClass: string;
  fieldClass?: string;
  attribute: string;
  label?: string;
  placeholder?: string;
  modelValue?: number | string;
  required?: boolean;
  min?: number;
  max?: number;
  width?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'number-field',
  props: {
    formClass: {},
    fieldClass: { default: "" },
    attribute: {},
    label: {},
    placeholder: { default: "" },
    modelValue: { default: "" },
    required: { type: Boolean, default: false },
    min: { default: 0 },
    max: {},
    width: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const dataValue = ref(props.modelValue);

// Handle input events with proper typing
function handleInput(event: Event) {
  const target = event.target as HTMLInputElement;
  emit("update:modelValue", target.value);
}

watch(
  () => props.modelValue,
  (newVal) => {
    dataValue.value = newVal;
  }
);

const numberFieldName = computed(() => `${props.formClass}[${props.attribute}]`);
const numberFieldId = computed(() => `${props.formClass}_${props.attribute}`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["field", __props.fieldClass])
  }, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: "label",
          for: numberFieldId.value
        }, _toDisplayString(__props.label), 9, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        autocomplete: "off",
        class: "input",
        type: "number",
        placeholder: __props.placeholder,
        min: __props.min,
        max: __props.max,
        required: __props.required,
        name: numberFieldName.value,
        id: numberFieldId.value,
        value: dataValue.value,
        onInput: handleInput,
        style: _normalizeStyle({ width: __props.width ?? '100%' })
      }, null, 44, _hoisted_3)
    ])
  ], 2))
}
}

})